/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：451
 */

var /* [auto-meaningful-name] */Array$isArray = Array.isArray
module.exports = Array$isArray
